import { render, staticRenderFns } from "./template.html?vue&type=template&id=fca8a5a0&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca8a5a0')) {
      api.createRecord('fca8a5a0', component.options)
    } else {
      api.reload('fca8a5a0', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=fca8a5a0&", function () {
      api.rerender('fca8a5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp2/radio/component.vue"
export default component.exports